import useVideoStatusChecker from '@anm/hooks/useVideoStatusChecker';
import { parseManifest, supportedExtensions } from '@anm/hosting-player';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { videoFolderActions } from '../../../../store/modules/videoFolder';

type PreviewState = {
  width: number;
  height: number;
  imgSrc: string;
};

type UpdatePreviewProps = {
  id: string;
  isCreated: boolean;
  shouldUpdatePreview?: boolean;
};

const useUpdatePreview = ({ id, isCreated, shouldUpdatePreview }: UpdatePreviewProps) => {
  const [preview, setPreview] = useState<PreviewState | null>(null);
  const dispatch = useDispatch();
  const canCheck = isCreated && shouldUpdatePreview;

  const { isMediaReady, videoManifest } = useVideoStatusChecker({
    hostId: id,
    supportedExtensions,
    source: 'api',
    mediaType: 'image',
    progress: canCheck ? 100 : null
  });

  useEffect(() => {
    if (!isMediaReady || !videoManifest) return;

    const { poster, sizes } = parseManifest(videoManifest);

    setPreview({
      imgSrc: poster.posterUrl,
      ...sizes
    });
  }, [isMediaReady, videoManifest]);

  useEffect(() => {
    if (!preview) return;

    const { imgSrc, ...sizes } = preview;

    dispatch(
      videoFolderActions.updateProjectPreview({
        id,
        preview: imgSrc,
        ...sizes
      })
    );
  }, [preview]);

  return preview;
};

export default useUpdatePreview;
